module.exports = __webpack_public_path__ + "static/media/made-of-honor.40e10447.webp";